module.exports = __webpack_public_path__ + "media/images/icons/country_flags/am-683c20ed58f4d94748560f8529a6726d.svg";